import styled from "styled-components"


export const StyledProjectSection = styled.div`
  max-width: 1000px;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  margin: 0 auto;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (min-width: 1500px) {
    grid-template-columns: 1fr 1fr 1fr;
    max-width: 1300px;
  }
  & img {
    border-radius:17px;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;


export const IconsContainer = styled(StyledProjectSection)`
  gap: 4em;
  @media screen and (min-width: 400px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (min-width: 900px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;


export const StyledProjectSectionContainer = styled.div`
  /* margin:; */
  background-color: ${({ bColor }) => bColor};
  h1 {
    font-size:2.3em;
    padding:2em;
    text-align: center;
  }
`;